import { render, staticRenderFns } from "./Question.vue?vue&type=template&id=7a512112&scoped=true&"
var script = {}
import style0 from "./Question.vue?vue&type=style&index=0&id=7a512112&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "7a512112",
  null
  
)

export default component.exports